import React from 'react';

import GenericContextMenu from '../../../components/buttons/GenericContextMenu';

import faCog from '@fortawesome/fontawesome-pro-light/faCog';

const PanelWrapper = ({
  position,
  callback,
  dropdownItemMap,
  title,
  enableDashboardLayout,
  panelClassName,
  children,
}) => (
  <React.Fragment>
    <div className="panel-alignment">
      <span className="panel-label">{title}</span>
      {enableDashboardLayout && (
        <GenericContextMenu
          position={position}
          callback={callback}
          icon={faCog}
          items={dropdownItemMap}
          titleRetrieval="title"
          callbackRetrieval="key"
          styleOverrides={{ background: 'transparent', padding: '0px 0px 0px 12px' }}
        />
      )}
    </div>
    {children}
  </React.Fragment>
);

export default PanelWrapper;



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/PanelWrapper.js